/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ProfileIcon = /*#__PURE__*/ createSvgIcon(
  'ProfileIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.938 14.063a8.33 8.33 0 012.406-1.178A9.172 9.172 0 0110 12.5c.917 0 1.802.129 2.656.385a8.33 8.33 0 012.406 1.178 5.747 5.747 0 001.084-1.896A6.685 6.685 0 0016.5 10c0-1.801-.633-3.335-1.9-4.6-1.268-1.267-2.802-1.9-4.605-1.9-1.802 0-3.335.633-4.6 1.9C4.133 6.664 3.5 8.198 3.5 10c0 .75.118 1.472.354 2.167a5.747 5.747 0 001.083 1.896zM10 11.5a2.893 2.893 0 01-2.125-.875A2.893 2.893 0 017 8.5c0-.833.292-1.542.875-2.125A2.893 2.893 0 0110 5.5c.833 0 1.542.292 2.125.875S13 7.667 13 8.5s-.292 1.542-.875 2.125A2.893 2.893 0 0110 11.5zm.006 6.5a7.81 7.81 0 01-3.11-.625 8.064 8.064 0 01-2.552-1.719 8.065 8.065 0 01-1.719-2.551A7.819 7.819 0 012 9.99c0-1.104.208-2.14.625-3.105a8.066 8.066 0 014.27-4.26A7.819 7.819 0 0110.01 2a7.75 7.75 0 013.105.625 8.082 8.082 0 014.26 4.265A7.77 7.77 0 0118 9.994a7.81 7.81 0 01-.625 3.11 8.063 8.063 0 01-1.719 2.552 8.081 8.081 0 01-2.546 1.719 7.77 7.77 0 01-3.104.625zM10 16.5c.722 0 1.417-.115 2.083-.344a6.64 6.64 0 001.875-1.01 7.495 7.495 0 00-1.896-.854A7.327 7.327 0 0010 14c-.708 0-1.4.094-2.073.281a6.542 6.542 0 00-1.885.865 6.641 6.641 0 001.875 1.01c.666.23 1.36.344 2.083.344zm0-6.5c.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.447 1.447 0 0010 7c-.417 0-.77.146-1.063.438A1.447 1.447 0 008.5 8.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ProfileIcon;
